import { createAction, props } from "@ngrx/store";
import { RemarkData } from "../../models/remarkDataModel";
import { GetAllWrappedResponse } from "../../models/getAllWrappedDataModel";

export const fetchCurrentAndNextYearTrafficData = createAction(
    '[Create or Edit] Fetch traffic data for current and next year'
)

export const fetchCurrentYearTrafficData = createAction(
    '[Create or Edit] Fetch traffic data for current year'
)

export const updateTrafficData = createAction(
    '[Create or Edit] Update traffic data',
    props<{ trafficData: GetAllWrappedResponse["data"] }>()
)

export const clearRemarkData = createAction(
    '[Create or Edit] Clear Remark data'
)

export const fetchRemarkData = createAction(
    '[Create or Edit] Fetch Remark data',
    props<{ remarkId: string }>()
)

export const setRemarkData = createAction(
    '[Create or Edit] Set Remark data',
    props<{ remark: RemarkData }>()
)

export const updateRemarkData = createAction(
    '[Create or Edit] Update Remark data',
    props<{ remark: RemarkData }>()
)

export const createRemarkData = createAction(
    '[Create or Edit] Create new Remark data',
    props<{ remark: RemarkData }>()
)

export const fetchTrafficDataError = createAction(
    '[Create or Edit] Fetch Traffic Data Error',
    props<{ error: any }>()
)

export const fetchRemarkDataError = createAction(
    '[Create or Edit] Fetch Remark Data Error',
    props<{ error: any }>()
)

export const updateRemarkDataError = createAction(
    '[Create or Edit] Update Remark Data Error',
    props<{ error: any }>()
)

export const updateRemarkDataSuccess = createAction(
    '[Create or Edit] Update Remark Data Success'
)

export const createRemarkDataError = createAction(
    '[Create or Edit] Create Remark Data Error',
    props<{ error: any }>()
)

export const createRemarkDataSuccess = createAction(
    '[Create or Edit] Create Remark Data Success',
    props<{ remarkId: string }>()
)